import { getFetcher } from 'api/swr'

/** 列表不再带 drawData；需要还原编辑器时再拉详情 */
export async function resolveAvatarOutfit(avatar) {
  let drawData = avatar?.drawData
  let spineDrawData = avatar?.spineDrawData
  let tid = avatar?.tid
  if (!drawData && avatar?.id) {
    const detail = await getFetcher(`/avatars/${encodeURIComponent(avatar.id)}`)
    drawData = detail?.drawData
    spineDrawData = detail?.spineDrawData ?? spineDrawData
    tid = detail?.tid || tid
  }
  if (!drawData) {
    throw new Error('Missing drawData')
  }
  const parsed = typeof drawData === 'string' ? JSON.parse(drawData) : drawData
  return {
    drawers: parsed?.drawers || [],
    tonings: parsed?.tonings || {},
    spineDrawData,
    tid,
  }
}
